import { ProductInfoType } from '@/api/fetchProductData'
import { fetchRoomProductData } from '@/api/fetchRoomProductData'
import { QUERY_KEY } from '@/constants/queryKey'
import { useRouter } from 'next/router'
import { useQuery } from 'react-query'

// 房間產品資訊

export type ProductListData = {
  productInfo: ProductInfoType
  isDel: boolean
  isTop: boolean
  sort: number
  sortName: string
  isLive?: boolean
}

export const useLiveRoomProduct = (props: {
  roomId: string
  liveRoomProductDataSSR?: any
  enabled?: boolean
}): {
  productList: ProductListData[]
  isRoomProductDataFetching: boolean
  refetchRoomProductData: () => void
  isRoomProductListFetched: boolean
} => {
  const router = useRouter()
  const { roomId, liveRoomProductDataSSR, enabled = true } = props
  const {
    data: productList = [],
    isFetching: isRoomProductDataFetching,
    refetch: refetchRoomProductData,
    isFetched: isRoomProductListFetched,
  } = useQuery([QUERY_KEY.FETCH_ROOM_PRODUCT_DATA, { roomId }], () => fetchRoomProductData({ roomId }), {
    enabled: !!roomId && router.isReady && enabled,
    ...(liveRoomProductDataSSR ? { initialData: liveRoomProductDataSSR } : {}),
  })
  return {
    productList,
    isRoomProductDataFetching,
    refetchRoomProductData,
    isRoomProductListFetched,
  }
}
